import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import CandidateCard from "../../assets/cards/CandidateCard";

export default function RecentlyJoined({ candidates }) {
  return (
    <>
      <Box my={8} >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "26px",
              lineHeight: "32px",
            }}
          >
            Recently Joined Candidates
          </Typography>
          <Link style={{ textDecoration: 'none', color: '#2544EE' }}>
            <Typography >View More </Typography>
          </Link>
        </Box>
        <Box>
          <Grid container spacing={2} mb={10}>
            {
              candidates && candidates.length > 0
                ?
                candidates.slice(0,4).map((item, index) => (
                  <Grid item md={3}>
                    <CandidateCard candidate={item}/>
                  </Grid>
                ))
                :
                ""
            }
          </Grid>
        </Box>
      </Box>
    </>
  );
}
